/** Route-owned basket selection, independent of which navigation section is open. */
export function isLatticeScanRoute(pathname: string, search = '') {
  const path = pathname.replace(/\/+$/, '') || '/';
  return path === '/home' && new URLSearchParams(search).get('mode') === 'lattice';
}

export function basketContextForRoute(pathname: string, search = ''): 'personal' | 'personnel' {
  const path = pathname.replace(/\/+$/, '') || '/';
  return path === '/home/scout' || isLatticeScanRoute(path, search) ? 'personnel' : 'personal';
}

/** Unfinished personnel pages are available only to admins for now. */
export function isRestrictedWorkspaceRoute(pathname: string, search = '') {
  const path = pathname.replace(/\/+$/, '') || '/';
  return /^\/home\/(scout|merchant)(\/|$)/.test(path) || isLatticeScanRoute(path, search);
}
